import { useState } from 'react'
import { useLanguage } from '@context/LanguageContext'
import { LANGUAGE_INFO } from '@constants/languages'
import Carousel from '../Carousel'
import styles from './LanguageSelector.module.css'

export default function LanguageSelector () {
  const { t, lang, setLang } = useLanguage()
  const [showSelector, setShowSelector] = useState(false)

  const getCurrentIndex = () => {
    const index = LANGUAGE_INFO.findIndex(language => language.code === lang)
    return index !== -1 ? index : 0
  }

  const getDisplayName = (item) => {
    return item.name
  }

  const handleSelect = (selectedItem) => {
    setLang(selectedItem.code)
    setShowSelector(false)
  }

  const handleClose = () => {
    setShowSelector(false)
  }

  const currentLanguage = LANGUAGE_INFO[getCurrentIndex()]

  return (
    <>
      <button
        type='button'
        onClick={() => setShowSelector(true)}
        className={styles.button}
        aria-label={getDisplayName(currentLanguage)}
        title={getDisplayName(currentLanguage)}
      >
        <img
          src={currentLanguage.image}
          alt={getDisplayName(currentLanguage)}
          width='30'
          height='20'
          className={styles.flag}
          aria-hidden='true'
        />
      </button>

      {showSelector && (
        <Carousel
          items={LANGUAGE_INFO}
          currentIndex={getCurrentIndex()}
          onSelect={handleSelect}
          onClose={handleClose}
          variant='modal'
          imageType='flag'
          showName
          ariaLabel={t.core.access.language.selector}
          instructions={t.core.access.language.instructions}
          getDisplayName={getDisplayName}
        />
      )}
    </>
  )
}
